(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('br-mobile-sort')) {
  customElements.define('br-mobile-sort', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const disclosure = this.querySelector('details');
      const trigger = this.querySelector('summary');
      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) return;
        const currentUrl = new URL(window.location.href);
        const selected = currentUrl.searchParams.get('sort_by') || document.getElementById('SortBy-mobile')?.value;
        this.querySelectorAll('[data-sort-value]').forEach(link => {
          const target = new URL(currentUrl);
          target.searchParams.set('sort_by', link.dataset.sortValue);
          target.searchParams.delete('page');
          target.searchParams.delete('section_id');
          link.href = target.pathname + target.search + target.hash;
          if (link.dataset.sortValue === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) disclosure.open = false;
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && disclosure.open) {
          event.preventDefault();
          event.stopPropagation();
          disclosure.open = false;
          trigger.focus();
        }
      }, { signal });
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const setup = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (initialized.has(gallery)) return;
      initialized.add(gallery);
      const connection = navigator.connection;
      if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      const list = gallery.querySelector('.product__media-list');
      if (!list) return;
      let timer;
      let waiting;
      const items = () => Array.from(list.querySelectorAll('.product__media-item'))
        .filter((item) => !item.classList.contains('hidden'));
      const warm = (item) => {
        const image = item?.querySelector('.product__media img');
        if (!image || image.complete && image.naturalWidth > 0) return;
        image.setAttribute('fetchpriority', 'low');
        image.loading = 'eager';
      };
      const prepare = () => {
        if (!gallery.isConnected) return;
        const visible = items();
        const desktopCurrent = Math.max(0, visible.findIndex((item) => item.classList.contains('is-active')));
        const mobileCurrent = Number(gallery.querySelector('.slider-counter--current')?.textContent) - 1;
        const current = matchMedia('(max-width: 749px)').matches && mobileCurrent >= 0 && mobileCurrent < visible.length
          ? mobileCurrent : desktopCurrent;
        const image = visible[current]?.querySelector('.product__media img');
        if (image && !image.complete) {
          if (waiting !== image) {
            waiting = image;
            image.addEventListener('load', schedule, { once: true });
          }
          return;
        }
        warm(visible[current + 1]);
        warm(visible[current + 2]);
      };
      const schedule = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(prepare, { timeout: 1500 });
          } else {
            prepare();
          }
        }, 120);
      };
      const anticipate = (event) => {
        const target = event.target instanceof Element ? event.target.closest('[data-target]') : null;
        if (!target || !gallery.contains(target) || target.classList.contains('hidden')) return;
        const item = Array.from(list.querySelectorAll('[data-media-id]'))
          .find((candidate) => candidate.dataset.mediaId === target.dataset.target);
        if (item && !item.classList.contains('hidden')) warm(item);
      };
      gallery.addEventListener('pointerover', anticipate, { passive: true });
      gallery.addEventListener('focusin', anticipate);
      list.addEventListener('scroll', schedule, { passive: true });
      gallery.addEventListener('click', anticipate, true);
      const observer = new MutationObserver(() => {
        if (!gallery.isConnected) {
          observer.disconnect();
          return;
        }
        schedule();
      });
      observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      schedule();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

})();
